import { checkDate, checkNotEmpty } from '~h/validators';

export const selfFormInputs = [
  {
    name: 'company',
    label: 'Название организации',
    type: 'company',
    classes: null,
    error: false,
    required: true,
    isForPersonal: false,
    validator: checkNotEmpty,
    renderBlock: 1,
  },
  {
    name: 'companyPosition',
    label: 'Должность',
    type: 'text',
    classes: null,
    error: false,
    required: true,
    isForPersonal: true,
    validator: checkNotEmpty,
    renderBlock: 1,
  },
  {
    name: 'citizenship',
    label: 'Гражданство',
    type: 'country',
    classes: null,
    error: false,
    required: true,
    isForPersonal: true,
    validator: checkNotEmpty,
    renderBlock: 2,
  },
  {
    name: 'passport',
    label: 'Серия и номер паспорта',
    type: 'passport',
    classes: null,
    error: false,
    required: true,
    isForPaidEvents: true,
    validator: checkNotEmpty,
    renderBlock: 2,
  },
  {
    name: 'passportCreated',
    label: 'Дата выдачи',
    type: 'date',
    classes: null,
    error: false,
    required: true,
    isForPaidEvents: true,
    validator: checkDate,
    renderBlock: 2,
  },
  {
    name: 'passportPlaceCreated',
    label: 'Кем выдан',
    type: 'ufms',
    classes: 'inp--lg',
    error: false,
    required: true,
    isForPaidEvents: true,
    validator: checkNotEmpty,
    renderBlock: 3,
  },
  {
    name: 'birthday',
    label: 'Дата рождения',
    type: 'date',
    classes: null,
    error: false,
    required: true,
    isForPaidEvents: true,
    validator: checkDate,
    renderBlock: 3,
  },
  {
    name: 'addressOfRegistration',
    label: 'Адрес регистрации',
    type: 'address',
    classes: 'inp--lg',
    error: false,
    isForPaidEvents: true,
    required: true,
    validator: checkNotEmpty,
    renderBlock: 4,
  },
];
